import Component from '../colorz/Component';
import Device from '@utils/html/Device';
import {breakpointsApp} from '../colorz/configClrzApp';

export default class Timeline extends Component {
	onInit(el) {
		this.el = el;
		this.dates = this.el.querySelectorAll('.js-dates-mobile');
	}

	onReady() {
		this.isMobile = Device.width < breakpointsApp.desktop;

		if (this.isMobile) {
			this.updateVisibleClass();
		}
	}

	onScroll() {
		if (this.isMobile) {
			this.updateVisibleClass();
		}
	}

	isElementInViewport(el) {
		const rect = el.getBoundingClientRect();
		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		);
	}

	updateVisibleClass() {
		this.dates.forEach((el, index) => {
			if (this.isElementInViewport(el)) {
				el.classList.add('is-visible');

				if (
					this.dates[index + 1] &&
					this.isElementInViewport(this.dates[index + 1])
				) {
					el.classList.remove('is-visible');
				}
			} else {
				el.classList.remove('is-visible');
			}
		});
	}
}
